import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight, ChevronRight } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { CITIES } from "../mock";
import useSeo from "../hooks/useSeo";

export default function CitiesPage() {
  useSeo("Find Caregivers by City | SimplySitter", "Browse vetted nannies, babysitters, housekeepers and senior caregivers by city across the United States on SimplySitter.");
  return (
    <div>
      <Header />
      <section className="hero-gradient">
        <div className="max-w-7xl mx-auto px-5 pt-14 pb-12">
          <nav className="flex items-center gap-1.5 text-[13px] text-[#8a8285]">
            <Link to="/" className="hover:text-[#7c2233]">Home</Link>
            <ChevronRight className="w-3.5 h-3.5" />
            <span className="text-[#5a5254]">Cities</span>
          </nav>
          <h1 className="font-display text-4xl sm:text-5xl text-[#1f1a1b] mt-4">Find care in your city</h1>
          <p className="text-[17px] text-[#5a5254] mt-4 max-w-2xl leading-relaxed">
            SimplySitter connects families with vetted nannies, babysitters, housekeepers and senior care in cities across the United States.
          </p>
        </div>
      </section>

      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-5 py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {CITIES.map((c) => (
              <Link
                key={c.slug}
                to={`/city/${c.slug}`}
                className="group flex items-center justify-between rounded-2xl border border-black/[0.08] px-6 py-5 transition-all hover:border-[#7c2233]/30 hover:shadow-[0_18px_40px_-24px_rgba(124,34,51,0.35)]"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#f7e4e6] flex items-center justify-center">
                    <MapPin className="w-5 h-5 text-[#7c2233]" strokeWidth={1.7} />
                  </div>
                  <div>
                    <p className="font-display text-lg text-[#1f1a1b] leading-tight">{c.name}</p>
                    <p className="text-[13px] text-[#8a8285]">{c.state}</p>
                  </div>
                </div>
                <ArrowRight className="w-5 h-5 text-[#7c2233] transition-transform group-hover:translate-x-1" />
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
